import React from 'react';

import ClaimOwnerWithEdit from '../../../ClaimOwnerWithEdit';

import GenericClaimBarField from './GenericClaimBarField';

type FileOwnerProps = {
  displayName?: string;
};

const FileOwner = ({ displayName = 'File Owner' }: FileOwnerProps) => {
  return (
    <GenericClaimBarField title={displayName}>
      <ClaimOwnerWithEdit />
    </GenericClaimBarField>
  );
};

export default FileOwner;
